import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';
import { grid } from './std';

const {logger} = useBSSLogger();

const strentity = "tcomuni";

const retrieveComuni = async (nazione, term) => {
    const {data} = await getapiclient().post("tcomuni/trovacomune", {
        capcomune: term,
        idnazione: nazione.id     
    }) 

    

    const comuni = data ?? [];

    logger.debug("comuni filtrati per", nazione, term, comuni)
    return comuni; 
}

const comuneById = async (id) => {
    
    const data = await grid(strentity, {
        take: 1,
        skip: 0,
        page: 1,
        pageSize: 1,
        filter: {
            logic: 'and',
            filters: [
                {field: "id", operator: "eq", value: ""+id}
            ]
        }
    }) 

    const comune = data?.results?.[0] ?? null;

    logger.debug("ottenuto comune da id", id, comune)
    return comune; 
}

const comuniPaginatedGrid = async (cfg) => {

    const data = await grid(strentity, cfg)

    return data;
}

export {retrieveComuni, comuneById, comuniPaginatedGrid}
